import { render, staticRenderFns } from "./EditAIWidget.vue?vue&type=template&id=596085f8"
import script from "./EditAIWidget.vue?vue&type=script&lang=js"
export * from "./EditAIWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports